//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import {
  PrepaidConfirmationIssues,
  PrepaidIssueRow,
} from '@campaigns/utils/sampling/SamplingPrepaidValidationUtils';
import Icon from '@components/atoms/icon/Icon';
import {
  CaptionErrorText,
  CaptionText,
  TableHeaderCellText,
} from '@components/atoms/text/Text';
import { Table } from '@components/organisms/table/Table';
import { TableDataCell } from '@components/organisms/table/TableDataCell';
import { TableRow } from '@components/organisms/table/TableRow';

interface PrepaidIssuesTableProps {
  issues: PrepaidConfirmationIssues;
}

export const PrepaidIssuesTable = ({ issues }: PrepaidIssuesTableProps) => {
  const { rows } = issues;

  const headerCells = [
    <TableHeaderCellText justifyContent='flex-start' key='attribute'>
      ATTRIBUTE
    </TableHeaderCellText>,
    <TableHeaderCellText justifyContent='flex-start' key='purchase'>
      PURCHASED
    </TableHeaderCellText>,
    <TableHeaderCellText justifyContent='flex-start' key='request'>
      SELECTED
    </TableHeaderCellText>,
  ];

  return (
    <Table
      body={rows.map((row) => (
        <IssueTableRow key={row.attribute} row={row} />
      ))}
      headerCells={headerCells}
    />
  );
};
interface IssueTableRowProps {
  row: PrepaidIssueRow;
}

const IssueTableRow = ({ row }: IssueTableRowProps) => {
  return (
    <TableRow>
      <TableDataCell>
        <CaptionText>{row.attribute}</CaptionText>
      </TableDataCell>
      <TableDataCell>
        <CaptionText>{row.purchaseValue}</CaptionText>
      </TableDataCell>
      <TableDataCell>
        <CaptionErrorText>
          <FormValueCell>
            <InheritColorIcon name='error' />
            {row.formValue}
          </FormValueCell>
        </CaptionErrorText>
      </TableDataCell>
    </TableRow>
  );
};

const FormValueCell = styled.div(
  ({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.spacings[2]};
`,
);

const InheritColorIcon = styled(Icon)`
  color: inherit;
  flex-shrink: 0;
`;
